<template>
  <div class="shadow-lg border-0 mb-2">
    <div class="card-body p-2">
      <div class="d-flex align-items-start gap-3">
        <h5 class="py-1"><font-awesome-icon :icon="['fas', 'filter']" class="text-secondary"/> <small class="text-muted">Filtry</small></h5>
        <div class="vr"></div>
        <button class="btn btn-danger" @click="clearFilters"><font-awesome-icon :icon="['fas','filter-circle-xmark']"/></button>
        <button
            v-for="space in spacesList"
            :key="space.Id"
            class="btn"
            :class="isActiveSpace(space.Id) ? 'btn-success' : 'btn-outline-secondary'"
            @click="filterSpace(space.Id)"
        >
          Stanowisko: {{ space.Name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {fetchWrapper} from "@/wrappers/api/fetchWrapper";

export default {
  name: 'FiltersSection',
  components: {FontAwesomeIcon},
  emits: ['filter-space'],
  data() {
    return {
      spacesList: [],
      filters: {
        spaces: []
      }
    }
  },
  async mounted() {
    await this.fetchSpaces();
  },
  methods: {
    async fetchSpaces() {
      try {
        const response = await fetchWrapper.get('/spaces/location/1');
        this.spacesList = response.locationSpaces || [];
      } catch (error) {
        console.error('Failed to fetch spaces:', error);
      }
    },
    filterSpace(spaceId) {
      if (this.filters.spaces.includes(spaceId)) {
        this.filters.spaces = this.filters.spaces.filter(id => id !== spaceId);
      } else {
        this.filters.spaces.push(spaceId);
      }
      this.$emit('filter-space', this.filters.spaces);
    },
    isActiveSpace(spaceId) {
      return this.filters.spaces.includes(spaceId);
    },
    clearFilters() {
      this.filters.spaces = [];
      this.$emit('filter-space', this.filters.spaces);
    }
  }
}
</script>

<style scoped>

</style>